import type { FaireProductEntity } from "../../entity_types/product";

export const p_h944q3wztf: FaireProductEntity = {
  token: "p_h944q3wztf",
  type: "product",
  name: "Harvest | Mulled Apple Cider | 9oz Fall Candle",
  brandToken: "b_uckpbd2jy4",
  brandName: "Modern Roots Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/295b8aaf6fbd0f4f2ba4dee44cac855b5cd135486ce319b7417b428933b6f288.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9d30d796db0e8616a0eabe29176701b8f20abe5133574ff565082bbb833397e1.png",
    "https://cdn.faire.com/fastly/bdab22cf0ba6998e0b6526a1e306e9f33d0068b65cdb48d9f442a894cf108d72.png",
    "https://cdn.faire.com/fastly/0b0d74e2d1382d2e9a416c8995087149efaae20b54ce354605ff8a690b73375f.png",
    "https://cdn.faire.com/fastly/aaf38c043017181c6ab9e04468467483efc193ac3bc699477f9e54a6cd6817d9.png",
    "https://cdn.faire.com/fastly/4ab66c59e59bfcdc8cf92feec8f97584823e8b2ecb834a3c845fbb5b72bdfd1b.png",
  ],
  priceDollars: 12,
  description:
    "“Let us not become weary in doing good, for at the proper time we will reap a harvest if we do not give up.” — Galatians 6:9\n\nWarm and inviting, Harvest fills your space with the comforting aroma of mulled apple cider. Bright notes of orange peel, lemon, and cinnamon mingle with cranberry, red currant, and crisp apple cider, while rich notes of red wine and wood create a cozy, spiced finish.\n\nScent Notes: Orange Peel, Cinnamon, Lemon, Cranberry, Red Currant, Apple Cider, Red Wine, Wood\n\nOur candles at Modern Roots Candle Co. are hand-poured in small batches and tested to precision. All candles are made with 100% natural soy wax, cotton braided wick, and clean fragrances infused with essential oils and free of phthalates. This combination makes for a cleaner and longer burn time.\n\nSingle Wick candles are great for bedrooms and bathrooms.\n\nOur labels are printed on estate #9 paper for a premium textured feel.\n\n9 oz. Candle Burn Time: Up to 45 Hours",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:01.804Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
